module.exports = __webpack_public_path__ + "static/media/KaTeX_Size1-Regular.10ec8be6.woff2";